import { render, staticRenderFns } from "./PrintLabels.vue?vue&type=template&id=2c97aed4&scoped=true"
import script from "./PrintLabels.vue?vue&type=script&lang=js"
export * from "./PrintLabels.vue?vue&type=script&lang=js"
import style0 from "./PrintLabels.vue?vue&type=style&index=0&id=2c97aed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97aed4",
  null
  
)

export default component.exports